export default class BreakpointWatcher {
	constructor(settings) {
		this.breakpoints = settings.breakpoints;
		this.targetedSelectors = [];
		this.resizeListeners = [];
		this.resizeEventSetup = false;
		this.currentBp = -1;
	}

	static init(settings) {
		if (!BreakpointWatcher.instance && settings.breakpoints) {
			BreakpointWatcher.instance = new BreakpointWatcher(settings);
		}
	}

	static register(selector) {
		BreakpointWatcher.instance.setupResizeEvent.call(BreakpointWatcher.instance);
		BreakpointWatcher.instance.targetedSelectors.push(selector);
		BreakpointWatcher.instance.currentBp = -1;
		BreakpointWatcher.instance.resize.call(BreakpointWatcher.instance);
	}

	static registerListener(event) {
		BreakpointWatcher.instance.setupResizeEvent.call(BreakpointWatcher.instance);
		BreakpointWatcher.instance.resizeListeners.push(event);

		if (BreakpointWatcher.instance.currentBp === -1) {
			BreakpointWatcher.instance.currentBp = BreakpointWatcher.getActiveBreakpoint().name;
		}

		event(BreakpointWatcher.instance.currentBp, -1);
	}

	static getActiveBreakpoint(allowedBps = null) {
		let activeBp = '';

		Object.keys(BreakpointWatcher.instance.breakpoints).forEach((bp) => {
			const bpSize = BreakpointWatcher.instance.breakpoints[bp];
			if (allowedBps === null || allowedBps.indexOf(bp) >= 0) {
				if (window.matchMedia(`(min-width: ${bpSize}px)`).matches) {
					activeBp = { name: bp, size: bpSize };
				}
			}
		});

		return activeBp;
	}

	setupResizeEvent() {
		if (!this.resizeEventSetup) {
			// Create debounced resize event if this is the first watcher.
			let resizeTimeout;
			window.onresize = () => {
				clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(() => BreakpointWatcher.instance.resize(), 100);
			};
			this.resizeEventSetup = true;
		}
	}

	resize() {
		/* global jQuery */
		const newBp = BreakpointWatcher.getActiveBreakpoint().name;

		if (newBp !== this.currentBp) {
			// Trigger listeners.
			const oldBp = this.currentBp;
			this.currentBp = newBp;
			jQuery.each(this.resizeListeners, (index, item) => { item(newBp, oldBp); });

			// Update managed objects.
			for (let i = 0; i < this.targetedSelectors.length; i += 1) {
				jQuery.each(jQuery(`${this.targetedSelectors[i]}.${newBp}`), (index, item) => {
					const $item = jQuery(item);
					$item.attr('style', BreakpointWatcher.getOrderString(parseInt($item.data(`${newBp}-order`), 10)));
				});

				jQuery(`${this.targetedSelectors[i]}:not(.${newBp})`).attr('style', 'display:none;');
			}
		}
	}

	static getOrderString(order) {
		return `-webkit-box-ordinal-group: ${order + 1}; order: ${order};`;
	}
}
